import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { BaseComponent } from '../BaseComponent.js';
const renderer = (color) => _jsx("circle", { cx: '12', cy: '12', r: '6', fill: color });
export const Dot = forwardRef(function Dot({ dataTestId, ...props }, ref) {
    return _jsx(BaseComponent, { ref: ref, dataTestId: dataTestId ?? 'dot-icon-svg', iconRender: renderer, ...props });
});
